import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import DetailHeader from '../../components/generics/DetailHeader';
import ListGeneralItems from '../../components/sessions/ListGeneralItems';
import Spinner from '../../components/generics/Spinner';

import {
  cleanSession,
  fetchSession,
  fetchSessionSuccess,
  fetchSessionFailure,
  fetchSessionDetail,
  fetchSessionDetailSuccess,
  fetchSessionDetailFailure,
} from "../../store/sessions/actions";
import { withRouter } from "utils/WithRouter";

export class ViewProductionContainer extends Component {
  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props) {
    super(props);

    this.state = {
      ingredients: [],
      leftovers: [],
      products: [],
    }
  }

  componentDidMount() {
    const sessionID = this.props.match.params.id;
    this.props.fetchSession(sessionID);
    this.props.fetchSessionDetail(sessionID);
  }

  componentWillUnmount() {
    this.props.cleanSession();
  }

  componentDidUpdate(prevProps) {
    const sessionID = parseInt(prevProps.match.params.id, 10);

    if (prevProps.session.loading && !this.props.session.loading) {
      if (!this.props.session.session.is_finished) {
        this.props.history.push('/session/' + prevProps.match.params.id + '/edit')
      }
    }
    if (prevProps.sessionDetail.loading && !this.props.sessionDetail.loading) {
      // The user can't see an in progress session
        const ingredients = [];
        const leftovers = [];
        const products = [];
        this.props.sessionDetail.detail.results.forEach((inventory) => {
          if (inventory.is_ingredient && inventory.session_ingredient === sessionID){
            ingredients.push(inventory);
          } else if (inventory.is_product && inventory.session_product === sessionID){
            products.push(inventory);
          } else {
            leftovers.push(inventory);
          }
        });
        this.setState({ ingredients, products, leftovers })
      }
    }

  // ---------------------------------------------------------------------------
  // Actions
  // ---------------------------------------------------------------------------
  goToLabels = () => {
    this.props.history.push(`/session/${this.props.match.params.id}/labels`);
  };

  goToEdit = () => {
    this.props.history.push(`/session/${this.props.match.params.id}/edit_finished`);
  };

  sessionIsEditable = () => {
    let editable = true;
    _.each(this.state.products, (prod) => {
      if (!prod.active) {
        editable = false;
        return;
      }
    });
    return editable;
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if(!this.props.session || this.props.session.loading ||
      !this.props.sessionDetail || this.props.sessionDetail.loading){
      return <Spinner />
    }else  {
      return (
        <div>
          <DetailHeader title="Production Session"
                        actionTitle="Labels"
                        action ={this.goToLabels}
                        actionClass="btn btn-primary m-0"
                        actionIconClass="fa fa-check mr-05"

                        action2Available={this.sessionIsEditable()}
                        action2Title="Edit"
                        action2 ={this.goToEdit}
                        action2Class="btn btn-danger m-0 mr-05"
                        action2IconClass="fa fa-edit mr-05"

                        col1Title="Session Number"
                        col1Desc={this.props.session.session.id}
                        col2Title="Date"
                        col2Desc={moment(this.props.session.session.date_created).format('LLL')}
                        col3Title="Station"
                        col3Desc={this.props.session.session.station.name} />

          <ListGeneralItems
            items={this.state.ingredients}
            isIngredient={true}
          />
          <ListGeneralItems
            items={this.state.leftovers}
            isLeftover={true}
          />
          <ListGeneralItems
            items={this.state.products}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    sessionDetail: state.sessions.productionSessionDetail,
    session: state.sessions.sessionDetail
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSession: (sId) => {
      dispatch(fetchSession(sId)).payload.then((response) => {
        dispatch(fetchSessionSuccess(response.data))
      }, (error) => {
        dispatch(fetchSessionFailure(error));
      });
    },
    cleanSession: () => {
      dispatch(cleanSession());
    },
    fetchSessionDetail: (iId) => {
      dispatch(fetchSessionDetail(iId)).payload.then((response) => {
        dispatch(fetchSessionDetailSuccess(response.data))
      }, (error) => {
        dispatch(fetchSessionDetailFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewProductionContainer));
